/**
 * Cuándo se lanza el recorrido (FEATURE-194): la señal de entrada y las condiciones.
 *
 * **La señal** de «esta persona acaba de autenticarse».
 *
 * Es lo que separa **entrar** de **recargar**. El recorrido se lanza al iniciar
 * sesión, no en cada montaje del shell: anclado al montaje, un F5 lo relanzaría en
 * medio del trabajo.
 *
 * Vive en `sessionStorage` y no en el estado del contexto de auth porque entre el
 * login y el panel hay una navegación completa: la marca tiene que sobrevivir a un
 * remonte del árbol **sin** sobrevivir a la pestaña. Por lo mismo no es una
 * preferencia: es «esto acaba de pasar», y se consume una sola vez.
 */

const CLAVE = "ld-login-reciente";

/** La deja puesta el flujo de login, ya autenticado. */
export function marcarLoginReciente(): void {
  try {
    sessionStorage.setItem(CLAVE, "1");
  } catch {
    // Modo privado o storage bloqueado: sin señal no se lanza el recorrido, que es
    // el lado seguro del error.
  }
}

/** Lee y borra en el mismo gesto: solo el primer lector se la lleva. */
export function consumirLoginReciente(): boolean {
  try {
    const hay = sessionStorage.getItem(CLAVE) === "1";
    if (hay) sessionStorage.removeItem(CLAVE);
    return hay;
  } catch {
    return false;
  }
}

/**
 * Las cuatro condiciones, juntas y no repartidas por el shell.
 *
 * Vive acá y no dentro del efecto para poder afirmarla: un predicado con cuatro
 * entradas tiene sus casos, y comprobarlos a mano en el navegador es lento y se
 * olvida. Ninguna de las cuatro agrega lecturas — son datos que el panel ya tiene.
 */
export function puedeLanzarse(estado: {
  /** La preferencia leída: `null` es «no se sabe», y no se lanza. */
  apagado: boolean | null;
  /** El alcance todavía resolviendo la cascada asociación → torneos → categorías. */
  cargando: boolean;
  /** La liga tiene al menos un torneo que señalar. */
  hayTorneo: boolean;
  /** Quien entra puede escribir: los pasos hablan de cargar, armar y publicar. */
  puedeEscribir: boolean;
}): boolean {
  return estado.apagado === false && !estado.cargando && estado.hayTorneo && estado.puedeEscribir;
}
